import { render, staticRenderFns } from "./MobileSalvarDados.vue?vue&type=template&id=e6cfb98e"
import script from "./MobileSalvarDados.vue?vue&type=script&lang=js"
export * from "./MobileSalvarDados.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports